import { render, staticRenderFns } from "./PopupDeliveryAddresses.vue?vue&type=template&id=64ab9026&scoped=true&"
import script from "./PopupDeliveryAddresses.vue?vue&type=script&lang=js&"
export * from "./PopupDeliveryAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab9026",
  null
  
)

export default component.exports